export default __webpack_public_path__ + "static/media/red_close_icon.b90c5851.png";